module.exports = __webpack_public_path__ + "img/map-location.ae7b280a.svg";